import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * @internal
 **/
export function toV12(registry, _ref) {
  var extrinsic = _ref.extrinsic,
      modules = _ref.modules;
  return registry.createTypeUnsafe('MetadataV12', [{
    extrinsic: extrinsic,
    modules: modules.map(function (mod) {
      return registry.createTypeUnsafe('ModuleMetadataV12', [_objectSpread(_objectSpread({}, mod), {}, {
        index: 255
      })]);
    })
  }]);
}